export default {
  RIGHT: 39,
  LEFT: 37,
  UP: 38,
  DOWN: 40,
  TAB: 9,
  ENTER: 13,
  SPACE: 32,
  BACKSPACE: 8,
  DELETE: 46,
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39,
  ESCAPE: 27,
  HYPHEN: 189,
  HYPHEN_FIREFOX: 173,
  A: 65,
  B: 66,
  C: 67,
  I: 73,
  S: 83,
  U: 85,
  V: 86,
  X: 88,
  Y: 89,
  Z: 90,
};
